import { render } from "./yearDetail.vue?vue&type=template&id=25f502be&scoped=true&ts=true"
import script from "./yearDetail.vue?vue&type=script&lang=ts&config=true"
export * from "./yearDetail.vue?vue&type=script&lang=ts&config=true"

import "./yearDetail.vue?vue&type=style&index=0&id=25f502be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f502be"]])

export default __exports__